export enum EFieldAction {
  create = 'create',
  edit = 'edit'
}
